<template>
  <field-group class="my-1" :label="label" inline>
    <v-select
      v-model="form"
      @click:clear="clearStyle()"
      :items="itemsImage"
      item-text="name"
      item-value="id"
      readonly
      clearable
    >
      <template #append-outer>
        <v-icon @click="onShowImageDialog()">mdi-plus</v-icon>
      </template>
    </v-select>
    <div v-if="itemsImage && itemsImage.length > 0">
      <v-img
        :src="itemsImage[0].patch"
        contain
        :aspect-ratio="4 / 3"
        style="border: 1px solid #7fb3d5"
      />
    </div>
    <IconDialog ref="icondialog" @submit="onSetImage" />
  </field-group>
</template>

<script>
import { API_SYMBOL } from '@/src/service/api/index.js'
import IconDialog from './icon-dialog.vue'
export default {
  components: { IconDialog },
  props: {
    label: String,
    value: {},
  },
  data: () => ({
    itemsImage: [],
  }),
  computed: {
    form: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {
    if (this.value) {
      API_SYMBOL.getDetail(this.value).then((res) => {
        this.itemsImage = [res.data]
      })
    }
  },
  methods: {
    onShowImageDialog() {
      this.$refs.icondialog.open()
    },
    onSetImage(image) {
      this.form = image.id
      this.itemsImage = [image]
    },
    clearStyle() {
      this.itemsImage = []
      this.form = undefined
    },
  },
}
</script>

<style scoped></style>
